import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { setDefaultValueForTree, toggleTreeList } from '@features/crm/utils/helpers';
import { generateCRMDashboardParams } from '@features/filter/static/filterUtil';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import { getCRMIndividualPerformance } from '@services/crmService';

import { convertNumberToUSFormat, getNumberUnit } from '@utils/Util';

const IndividualPerformance = () => {
	const filterFields = useSelector((store) => store.filterFieldStore);
	const [performances, setPerformances] = useState([]);
	const dispatch = useDispatch();

	const generateParams = () => {
		return {
			...generateCRMDashboardParams(filterFields)
		};
	};

	useEffect(() => {
		(async () => {
			try {
				dispatch(openLoader());
				const data = await getCRMIndividualPerformance(generateParams());
				let modifiedData = setDefaultValueForTree(data, 'brandWisePerformanceList');
				setPerformances(modifiedData);
				dispatch(closeLoader());
			} catch {
				dispatch(closeLoader());
			}
		})();
	}, [filterFields]);

	const toggleTreeNode = (isRootNode, nodeInfo) => {
		const modifiedData = toggleTreeList(performances, isRootNode, nodeInfo, 'brandWisePerformanceList');
		setPerformances(modifiedData);
	};

	const renderTableRow = (item, isRootNode, idx = 0) => {
		return (
			<React.Fragment key={`child-level-${idx}_${item.uId}`}>
				{item.isOpen && (
					<tr className={isRootNode ? 'parent' : `child-level-${idx}`}>
						<td>
							{item?.brandWisePerformanceList && item?.brandWisePerformanceList.length > 0 && (
								<p
									className="regular-14 gray_dark_01 cursor-pointer"
									onClick={() => toggleTreeNode(isRootNode, item)}
								>
									{item.isChildOpen ? '-' : '+'}
									{item.teamMember?.name}
								</p>
							)}
							{!item?.brandWisePerformanceList && (
								<p className="regular-14 gray_dark_01">{item?.brand?.name}</p>
							)}
						</td>

						<td>
							<p className="regular-14 gray_dark_01">{getNumberUnit(item?.targetAmount)}</p>
						</td>
						<td>
							<p className="regular-14 gray_dark_01">{getNumberUnit(item?.pipelineAmount)}</p>
						</td>
						<td>
							<p className="regular-14 gray_dark_01">{getNumberUnit(item?.achievedAmount)}</p>
						</td>
						<td>
							<p className="regular-14 gray_dark_01">
								{convertNumberToUSFormat(item?.noOfTargetDesign)}
							</p>
						</td>
						<td>
							<p className="regular-14 gray_dark_01">
								{convertNumberToUSFormat(item?.noOfAchievedDesign)}
							</p>
						</td>

						<td>
							{item.pipelineAmount !== 0 && (
								<p
									className="regular-14 blue d-flex align-items-center cursor-pointer"
									onClick={() => {
										let params = '';
										if (item?.teamMember?.id) {
											params += `&memberId=${item.teamMember.id}&memberName=${item.teamMember.name}`;
										}
										if (item?.brand?.id) {
											params += `&brandId=${item.brand.id}&brandName=${item.brand.name}`;
										}
										window.open(`/crm?activeTab=SALES_FUNNEL${params}`);
									}}
								>
									View{' '}
									<img
										src={`${process.env.PUBLIC_URL}/icons/arrow-forward-blue.svg`}
										alt="arrow"
									/>
								</p>
							)}
						</td>
					</tr>
				)}
				{item?.brandWisePerformanceList &&
					item?.brandWisePerformanceList?.length &&
					item?.brandWisePerformanceList.map((child) => {
						return renderTableRow(child, false, idx + 1);
					})}
			</React.Fragment>
		);
	};

	const renderTableBody = () => {
		return performances?.map((item, index) => {
			return (
				<React.Fragment key={`individualPerformance_${item.uId}_${index}`}>
					{renderTableRow(item, true)}
				</React.Fragment>
			);
		});
	};

	return (
		<div className="individual-performance mt-12">
			<div className="performance-heading d-flex justify-content-between align-items-center">
				<p className="regular-14 gray_dark_01 weight-500">Individual Performance</p>
			</div>
			<div className="performance-body scroll-x-label">
				<table className="table table-collapsable individual-performance-table with-border height-sm">
					<thead>
						<tr>
							<th rowSpan={2}>Team Member with Assigned Brands</th>
							<th colSpan={3} className="text-center">
								Sales
							</th>
							<th colSpan={2} className="text-center">
								Nitex Design
							</th>
							<th rowSpan={2}>Details</th>
						</tr>
						<tr>
							<th className="target">Target</th>
							<th className="pipeline">Pipeline</th>
							<th className="achieved">Achieved</th>
							<th className="target">Target</th>
							<th className="achieved">Achieved</th>
						</tr>
					</thead>
					<tbody>{renderTableBody()}</tbody>
				</table>
			</div>
		</div>
	);
};

export default IndividualPerformance;
